<div>
  <!-- UNMET Button -->
  <button class="btn btn-xs btn-danger align-items-center"
          *ngIf="id && (!status?.status || status.status === 1)"
          (click)="changeStatus.emit(true)"
          [disabled]="!canEdit">
    UNMET
  </button>

  <!-- MET Button -->
  <button class="btn btn-xs btn-success align-items-center"
          *ngIf="id && status?.status === 2"
          (click)="changeStatus.emit(false)"
          [disabled]="!canEdit">
    MET
  </button>

  <!-- Debug Information -->
  <div *ngIf="debug" class="debug-info mt-2">
    <p><strong>Debug Info:</strong></p>
    <ul>
      <li><strong>ID:</strong> {{ id }}</li>
      <li><strong>Status:</strong> {{ status | json }}</li>
      <li><strong>Can Edit:</strong> {{ canEdit }}</li>
    </ul>
  </div>
</div>
